import { CrmTaskStatus } from '@plato/data/prisma';
import { z } from 'zod';
import { richTextSchema } from '../types/common-types.ts';
import { uploadedFileSchema } from './crm-attachment-dto.ts';

export const crmTaskInputDtoSchema = z.object({
    description: richTextSchema,
    assignedToId: z.string().uuid().min(1),
    dueDate: z.date(),
    status: z.enum(CrmTaskStatus),
    links: z.array(
        z.object({
            modelType: z.string().min(1),
            modelId: z.string().min(1),
            title: z.string().nullable(),
        }),
    ),
    attachments: z.array(uploadedFileSchema).optional(),
});

export type CrmTaskInputDTO = z.infer<typeof crmTaskInputDtoSchema>;
